// =============================================================================
// Guide data — reads the topics tree PHP exposes for the current article
// (script[data-aa-tree]): { guideTitle, current, topics }.
// =============================================================================

let tree = null;

export function readTree() {
	if (tree !== null) {
		return tree;
	}
	const el = document.querySelector("script[data-aa-tree]");
	if (!el) {
		tree = false;
		return tree;
	}
	try {
		tree = JSON.parse(el.textContent) || false;
	} catch (e) {
		tree = false;
	}
	return tree;
}

/** The topic containing the current article (null when unassigned). */
export function activeTopic() {
	const t = readTree();
	if (!t || !Array.isArray(t.topics)) {
		return null;
	}
	return (
		t.topics.find((topic) =>
			(topic.steps || []).some(
				(step) =>
					step.slug === t.current ||
					(step.substeps || []).some((sub) => sub.slug === t.current)
			)
		) || null
	);
}
